import template from './tc-email.html';
import controller from './tc-email.controller';

let TcEmailComponent = {
  restrict: 'E',
  bindings: {
    ngModel: '=', // Two-way binding for the email value
    placeholder: '@?', // Optional placeholder text
    disabled: '<?', // Optional disabled state
    required: '<?', // Optional required state
    class: '@?', // Optional CSS classes
  },
  template,
  controller
};

export default TcEmailComponent;




// WEBPACK FOOTER //
// ./client/common/directives/email/tc-email.component.js